import { PaginatedRequestParams } from 'api';

export enum SponserFilterFormField {
  Name = 'name',
  IsActive = 'is_active',
  IsShowOnApp = 'is_show_on_app',
  IsSponserImage = 'type_id',
}
export type SponserFilterFormValues = {
  [SponserFilterFormField.Name]: string | undefined;
  [SponserFilterFormField.IsActive]: boolean | undefined;
  [SponserFilterFormField.IsShowOnApp]: boolean | undefined;
  [SponserFilterFormField.IsSponserImage]: boolean | undefined;
};

export type SponserFilterFormPaginated = SponserFilterFormValues &
  PaginatedRequestParams;
